import { AllowedActionsDto } from '@enterprise/models/allowed-actions';
import { AxiosResponse } from 'axios';
import CreateEnterprisePayload from '@enterprise/models/dto/enterprise-create.dto';
import { CreditConsumptionItem } from '@enterprise/models/get-credit-consumption';
import { CreditTopUp } from '@enterprise/models/get-credit-topup';
import EndPoints from '@services/endpoints';
import GetEnterpriseResponseDto from '@enterprise/models/dto/enterprise-get.dto.';
import IEnterprise from '../models/enterprise';
import IPaginatedParams from '@models/paginated-params';
import IPaginatedesponse from '@models/paginated-reponse';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import axiosClient from '@services/axiosClient';

export const getEnterprises = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<IPaginatedesponse<IEnterprise>>> => {
  return await axiosClient.post(
    EndPoints.enterprise.getEnterprises(paginatedParams),
    searchCriteria,
  );
};

export const disableEnterpriseById = async (
  id: string,
  payload: { sendEmail: boolean },
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(
    EndPoints.enterprise.disableEnterpriseById(id),
    payload,
  );
};

export const enableEnterpriseById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.enterprise.enableEnterpriseById(id));
};

export const createEnterprise = async (
  formData: FormData,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.post(
    EndPoints.enterprise.createEnterprise(),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const editEnterprise = async (
  id: string,
  formData: FormData | CreateEnterprisePayload,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.patch(
    EndPoints.enterprise.editEnterprise(id),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const getEnterpriseById = async (
  id: string | undefined,
): Promise<AxiosResponse<GetEnterpriseResponseDto>> => {
  return await axiosClient.get(EndPoints.enterprise.getEnterpriseById(id));
};

export const getEnterprisesSuggestions = async (
  params: IPaginatedParams,
): Promise<AxiosResponse<IPaginatedesponse<{ id: string; name: string }>>> => {
  return await axiosClient.get(
    EndPoints.enterprise.getEnterprisesSuggestions(params),
  );
};
export const getEnterpriseCreditsConsumption = async (
  id: string | undefined,
  params: IPaginatedParams,
): Promise<AxiosResponse<IPaginatedesponse<CreditConsumptionItem>>> => {
  return await axiosClient.get(
    EndPoints.enterprise.getEnterpriseCreditsConsumption(id, params),
  );
};

export const getEnterpriseCreditsTopUp = async (
  id: string | undefined,
  params: IPaginatedParams,
): Promise<AxiosResponse<IPaginatedesponse<CreditTopUp>>> => {
  return await axiosClient.get(
    EndPoints.enterprise.getEnterpriseCreditsTopUp(id, params),
  );
};

export const updateEnterpriseAllowedActions = async (
  id: string | undefined,
  payload: AllowedActionsDto,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.patch(
    EndPoints.enterprise.updateEnterpriseAllowedActions(id),
    payload,
  );
};
